import React, { useEffect, useState } from "react";
import {
  Box, Alert, CircularProgress,
  Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/layout/PageHeader";
import axios from "../../../config/axiosConfig";

const Th = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "0.78rem",
  padding: "3px 6px",
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
}));

// Mismo criterio que el resto del módulo: '0000-00-00' legacy llega como
// 30/11/1899, se muestra como "sin dato" en vez de esa fecha basura.
const formatFecha = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime()) || d.getFullYear() < 1950) return "-";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

const formatMonto = (value) =>
  `Bs ${Number(value || 0).toLocaleString("es-BO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const formatAntiguedad = ({ anios, meses } = {}) => `${anios} año(s) ${meses} mes(es)`;

const nombreCompleto = (r) => [r.nombre, r.paterno, r.materno].filter(Boolean).join(" ");

const AdministracionPersonalDetallePage = () => {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sinPermiso, setSinPermiso] = useState(false);

  useEffect(() => {
    axios.get("/api/administracion-personal/detalle-sueldos")
      .then(({ data }) => setLista(data?.data || []))
      .catch((e) => {
        if (e?.response?.status === 403) {
          setSinPermiso(true);
        } else {
          setError(e?.response?.data?.message || "Error al cargar el detalle.");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <DashboardLayout>
      <PageHeader
        title="Administración Personal"
        subtitle="Detalle de sueldos"
        backTo="/administracion-personal"
      />
      <Box sx={{ p: 1 }}>
        {sinPermiso ? (
          <Alert severity="warning">No tienes permiso para ver esta información.</Alert>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={24} />
          </Box>
        ) : lista.length === 0 ? (
          <Alert severity="info">No se encontraron registros.</Alert>
        ) : (
          <Paper variant="outlined">
            <TableContainer>
              <Table size="small" sx={{ "& td": { py: 0.4, px: 0.75, fontSize: "0.78rem" } }}>
                <TableHead>
                  <TableRow>
                    <Th>Nombre</Th>
                    <Th>Cargo</Th>
                    <Th align="right">Sueldo Básico</Th>
                    <Th align="right">Bono</Th>
                    <Th>Fecha de Inicio</Th>
                    <Th>Antigüedad</Th>
                    <Th>Departamento</Th>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {lista.map((r) => (
                    <TableRow key={r.id} hover>
                      <TableCell>{nombreCompleto(r)}</TableCell>
                      <TableCell>{r.cargo}</TableCell>
                      <TableCell align="right">{formatMonto(r.sueldo_basico)}</TableCell>
                      <TableCell align="right">{formatMonto(r.sueldo)}</TableCell>
                      <TableCell>{formatFecha(r.fecha_ini)}</TableCell>
                      <TableCell>{formatAntiguedad(r.antiguedad)}</TableCell>
                      <TableCell>{r.departamento}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default AdministracionPersonalDetallePage;
